import { connectRouter } from 'connected-react-router'
import type { History } from 'history'
import { combineReducers } from '@reduxjs/toolkit'
import login from '@views/loginView/state/loginSlice'
import tracking from '@views/tracking/state/trackingSlice2'
import signup from '@views/signupView/state/signupSlice'
import profile from '@views/profile/state/profileSlice'
import referral from '@views/referrals/state/referralSlice'
import resources from '@views/resources/state/resourcesSlice'
import configurations from '@views/configurations/state/configurationsSlice'
import club from '@views/club/state/clubSlice'
import verify from '@views/home/state/homeSlice'
import manage from '@views/manage/state/manageSlice'
import commissions from '@views/commissionsReferrals/state/commissionsSlice'
import prepayments from '@views/prepayments/state/prepaymentsSlice'
import analystTrack from '@views/analystTrack/state/analystTrackSlice'
import analystCases from '@views/analystCases/state/analystCasesSlice'
import analystRejected from '@views/analystRejected/state/analystRejectedSlice'
import executiveCommissions from '@views/executiveCommissions/state/executiveCommissionsSlice'
import agentCommissions from '@views/agentCommissions/state/agentCommissionsSlice'
import executiveMetrics from '@views/executiveMetrics/state/executiveMetricsSlice'
import agentMetrics from '@views/agentMetrics/state/agentMetricsSlice'

// this rules need to be disabled because otherwise the return type will need a
// lot of workarounds
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
const createReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    login,
    signup,
    club,
    profile,
    verify,
    tracking,
    referral,
    resources,
    configurations,
    manage,
    commissions,
    prepayments,
    analystTrack,
    analystCases,
    analystRejected,
    executiveCommissions,
    agentCommissions,
    agentMetrics,
    executiveMetrics
    // Add your reducers here
  })

export default createReducer
